<template>

    <b-navbar :class="{ 'top-navbar-bg-debug': isDebug, 'bg-light': !isDebug }" class="align-items-center shadow" sticky>

        <b-navbar-nav class="align-items-center flex-grow-1">
            <b-nav-item href="#">
                <b-button variant="link" v-b-toggle.main-sidebar>
                    <span class="h4"><b-icon icon="list"></b-icon></span>
                </b-button>
            </b-nav-item>
            <b-nav-item to="/dashboard">{{ appTitle }}</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="flex-grow-0 align-items-center">
            <b-nav-item to="/profile">
                <span class="d-flex flex-nowrap align-items-center">
                    <b-icon icon="person-circle" />
                    <span class="d-flex flex-column">
                        <small class="d-none d-sm-inline ml-2">{{ userFullName }}</small>
                        <small class="d-none d-sm-inline ml-2 text-secondary">{{ organizationName }}</small>
                    </span>
                </span>
            </b-nav-item>
            <b-nav-item href="#" @click="logout">
                <b-icon icon="box-arrow-right" />
            </b-nav-item>
        </b-navbar-nav>

    </b-navbar>

</template>
<script>
  import AuthConstants from "../../store/auth/constants";
  import UIConstants from "../../store/ui/constants";
  import { mapGetters } from 'vuex';
  import store from "../../store";
  import SingleSelect from "@/components/Select/SingleSelect.vue";

export default {
    computed: {
        ...mapGetters([ 'userFullName', 'userValidContractObjects', 'userLastValidContractObject', 'isInContractor', 'userOrganization']),
        organizationName() {
            return this.userOrganization['name']
        },
    },
    data() {
        return {
            form: {
                contract: {}
            },
            activeNotifications: false,
            title: ''
        };
    },
    methods: {
        logout() {
            this.$store.dispatch(AuthConstants.AuthActions.AUTH_LOGOUT)
                .then(() => {
                    store.dispatch(UIConstants.UIActions.UI_CLEAN_BREADCRUMBS);
                });
        },
        // onContractChanged(name, item) {
        //     this.$store.dispatch(AuthConstants.AuthActions.AUTH_CHANGE_CURRENT_CONTRACT, item)
        //         .then(() => { this.$bvToast.toast(item['explicit_description'], {title: 'Текущий контракт установлен', autoHideDelay: 5000, variant: 'success'}); })
        //         .catch(() => { this.$bvToast.toast(item['explicit_description'], {title: 'Не удалось сменить текущий контракт', autoHideDelay: 5000, variant: 'danger'}); })
        // },
    },
    mounted() {
        // this.form.contract = this.userLastValidContractObject
    }
};
</script>
<style>
.top-navbar-bg-debug {
    background-color: rgb(248, 200, 151);
}
</style>
